var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.82,
    height: 28,
    viewBox: "0 0 31.82 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_254",
    "data-name": "Group 254",
    transform: "translate(-771.18 -637)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(770.181 636)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M13.5,1A12.482,12.482,0,0,0,2.555,19.515L1.048,24.537A1.136,1.136,0,0,0,2.136,26a1.158,1.158,0,0,0,.327-.048l5.023-1.507A12.5,12.5,0,1,0,13.5,1Zm0,22.727a10.189,10.189,0,0,1-5.282-1.484,1.145,1.145,0,0,0-.59-.164,1.106,1.106,0,0,0-.326.048l-3.47,1.042L4.873,19.7a1.136,1.136,0,0,0-.114-.909A10.218,10.218,0,1,1,13.5,23.727Z",
    transform: "translate(0 0)",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.78b585f66a0f2f400ca5e2ef44606fbd.svg";
export { ForwardRef as ReactComponent };